import { useEffect } from 'react';
import { GuestFormFlow } from 'modules/guest-forms/GuestFormFlow';
import { GuestFormSessionProvider } from 'modules/guest-forms/GuestFormSessionProvider';

/**
 * Public, Auth0-free page for the magic-link form runner. Mounted OUTSIDE
 * Auth0ProviderWithNavigate so an invited applicant is never bounced to a login they cannot pass.
 *
 * The link token rides in `?t=`, so `Referrer-Policy: no-referrer` is set while this page is
 * mounted — otherwise the token would leak to any third-party asset via the Referer header.
 */
export const GuestFormPage = () => {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'referrer';
    meta.content = 'no-referrer';
    document.head.appendChild(meta);
    return () => {
      // remove() instead of head.removeChild(meta): translation extensions and in-app browsers
      // rewrite <head> behind React's back, and removeChild throws NotFoundError once the node has
      // been detached or re-parented. remove() is a no-op in that case. This page is reached from a
      // link in an email, so an in-app browser is the normal case here rather than the exotic one.
      meta.remove();
    };
  }, []);

  return (
    <GuestFormSessionProvider>
      <GuestFormFlow />
    </GuestFormSessionProvider>
  );
};
